import React from "react";
import type { UnitCategory } from "@/types";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface UnitTableCategoryFilterProps {
    categories: UnitCategory[];
    selectedCategories: number[];
    setSelectedCategories: React.Dispatch<React.SetStateAction<number[]>>;
}

export const UnitTableCategoryFilter: React.FC<
    UnitTableCategoryFilterProps
> = ({ categories, selectedCategories, setSelectedCategories }) => {

    const handleCheckboxChange = (category: number) => {
        setSelectedCategories((prev) => prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]);
    }

    const handleClearFilter = () => { 
        setSelectedCategories([]);
    }

    return categories.length > 0 ? (
        <div>
            <h3>Categories</h3>
            {categories.map((category) => (
                <div key={category.id} className="tw:items-start tw:flex tw:flex-row tw:space-x-3 tw:space-y-0">
                    <Checkbox id={category.slug} onCheckedChange={() => handleCheckboxChange(category.id)} checked={selectedCategories.includes(category.id)} />
                    <Label htmlFor={category.slug} className="tw:text-sm tw:font-normal tw:ml-2">
                        {category.name}
                    </Label>
                </div>
            ))}
            <Button onClick={handleClearFilter} variant="link" className="tw:text-sm tw:font-normal">Clear</Button>
        </div>
    ): null;
};
